import DeleteOffer from "./DeleteOffer";

export default DeleteOffer